"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderLawtext = void 0;
const std = __importStar(require("../law/std"));
const std_1 = require("../law/std");
const _any_1 = require("../parser/std/rules/$any");
const _law_1 = require("../parser/std/rules/$law");
const util_1 = require("../util");
const renderLawtext = (el, indentTexts = []) => {
    let ret = "";
    if (std.isLaw(el)) {
        const lines = (0, _law_1.lawToLines)(el, indentTexts);
        ret += lines.map(l => l.text()).join("");
    }
    else if ((0, std_1.isStdEL)(el) || (0, std_1.isControl)(el)) {
        const lines = (0, _any_1.anyToLines)(el, indentTexts);
        ret += lines.map(l => l.text()).join("");
    }
    else {
        throw new util_1.NotImplementedError(`render ${el.tag}`);
    }
    ret = ret.replace(/\r\n/g, "\n").replace(/\n/g, "\r\n").replace(/(\r?\n\r?\n)(?:\r?\n)+/g, "$1").replace(/(?:\r?\n)?$/, "\r\n").replace(/(?:\r?\n)+$/, "\r\n");
    return ret;
};
exports.renderLawtext = renderLawtext;
exports.default = exports.renderLawtext;
//# sourceMappingURL=lawtext.js.map